import { defineStore } from 'pinia';

export const useAppMessageStore = defineStore({
	id: 'app-message',
	state: () => ({
    modalMessage: '', // may be a object (depending server's response)
    hasError: false,
    onCloseCallback: null,
	}),
	getters: {
    getMessage: (state) => {
      return state.modalMessage
    },
    hasErrorFromServer: (state) => state.hasError
	},
	actions: {
		setMessage (message = '') {
      this.modalMessage = message;
    },
    setErrorModal (data = {}) {
      this.modalMessage = data.modalMessage;
      this.hasError = true;
      this.onCloseCallback = data.onClose || null;
    },
    setSuccessModal (data = {}) {
      this.modalMessage = data.modalMessage;
      this.hasError = false;
      this.onCloseCallback = data.onClose || null;
    },
	},
});
